import { TableCell, TableRow, Tooltip } from '@material-ui/core';
import { Message, Visibility } from '@material-ui/icons';
import React from 'react';
import { INumberedDocumentView, WorkflowStatusType } from '../../api-client/autogenerated';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import {
  ascendingComparator,
  descendingComparator,
} from '../../main-components/document-index/DocumentIndexUtils';
import { fileIsPdf, parseDate } from '../../scripts/utils';

const getUserFriendlyStatus = (status?: WorkflowStatusType | null) => {
  if (status === WorkflowStatusType.SubmittedForReview) return 'Submitted for Review';
  if (status === WorkflowStatusType.UnderReview) return 'Under Review';
  return 'Review Complete';
};

export default function getRFIRows(
  data: INumberedDocumentView[],
  handleClick?: (id?: string) => void,
) {
  return data
    .filter((doc) => doc.files?.length === 0 || doc.files?.every((f) => f.isVerified))
    .sort((a, b) => ascendingComparator(a, b, 'documentNumber'))
    .map((row) => {
      const dateElement = row.createdOn
        ? parseDate(row.createdOn).format('MM/DD/YYYY HH:mm')
        : 'N/A';
      const file =
        row.files && row.files.length > 0
          ? row.files.sort((a, b) => descendingComparator(a, b, 'createdOn'))[0]
          : undefined;
      return (
        <TableRow key={row.id}>
          <TableCell>{row.documentNumber}</TableCell>
          <TableCell>
            <strong>{dateElement}</strong>
          </TableCell>
          <TableCell>{row.contactName}</TableCell>
          <TableCell>{row.contactCompany}</TableCell>
          <TableCell>{row.description}</TableCell>
          <TableCell>{getUserFriendlyStatus(row.workflowStatus)}</TableCell>
          <TableCell>
            {file && fileIsPdf(file) && (
              <IconButton
                onClick={() => (handleClick ? handleClick(file.id) : null)}
                style={{ padding: 0 }}
              >
                <Visibility htmlColor="#000" style={{ marginLeft: 7 }} />
              </IconButton>
            )}
            {row.workflowStatus === WorkflowStatusType.Completed && row.reviewComment && (
              <Tooltip
                title={
                  <Typography style={{ textTransform: 'none' }}>{row.reviewComment}</Typography>
                }
                placement="top"
                arrow
              >
                <Message style={{ marginLeft: 8 }} />
              </Tooltip>
            )}
          </TableCell>
          <TableCell>{row.willPublishResponse ? 'Yes' : 'No'}</TableCell>
        </TableRow>
      );
    });
}
